import { combineReducers } from 'redux';
import invoices from './invoices';
import sales from './sales';
import shifts from './shifts';
import transactions from './transactions';

export default combineReducers({
  sales,
  salesType: sales,
  grossProfit: sales,
  paymentMethods: sales,
  itemSales: sales,
  categorySales: sales,
  modifierSales: sales,
  discounts: sales,
  taxes: sales,
  gratuities: sales,
  staffs: sales,
  servers: sales,
  shifts,
  transactions,
  invoices,
  showLoadingSpinnerReport: sales,
});
